
$(document).ready(function(){

  	 $(".all-box-cover-for-mobile").slick({
        arrows: true,
        dots: false,
        autoplay: true,
        speed: 600,
        fade: true,
        autoplaySpeed:2000,
        slidesToShow:1,
        slidesToScroll: 1,
        //cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
        touchThreshold: 100
      });
  
    var alterClass = function() {
    var ww = document.body.clientWidth;
    if (ww < 768)
    {
      $(".all-box-cover").hide();
      $(".all-box-cover-for-mobile").show();
       
    } 
     else
    {
     $(".all-box-cover").show();
      $(".all-box-cover-for-mobile").hide();
    } 
  };
  $(window).resize(function(){
    alterClass();
  });
  alterClass();
  
  
  
  
  


  $(".tired-slider").slick({
    arrows: true,
    dots: false,
    autoplay: false,
    speed: 600,
    fade: true,
    autoplaySpeed:800,
    slidesToShow:1,
    slidesToScroll: 1,
    cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
    touchThreshold: 100
  });




  $(".happy-slider").slick({
    infinite: true,
    arrows: false,
    dots: false,
    autoplay: false,
    speed: 800,
    autoplaySpeed:2000,
    slidesToShow:3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          adaptiveHeight: true

        }
      }
    ]
  });

  $(".feature-slider").slick({
    autoplay: true,
    dots: true,
    arrows: false,
    fade: true,
    cssEase: 'ease',
    customPaging : function(slider, i) {
      var thumb = $(slider.$slides[i]).data();
      return '<a class="dot">'+i+'</a>';
    }
  });

  $(".benifit-slider").slick({
    dots: false,
    autoplay: false,
    speed: 600,
    autoplaySpeed:800,
    slidesToShow:1,
    slidesToScroll: 1,
  });




  $(".testimonial-slider").slick({
    arrows: false,
    dots: false,
    autoplay: false,
    speed: 600,
    autoplaySpeed:1000,
    slidesToShow:1,
    slidesToScroll: 1,
  });

  $('.achieving-slider').slick({
    centerMode: true,
    centerPadding: '0px',
    slidesToShow: 3,
    arrows: true,
    dots: false,
    autoplay: false,
    responsive: [
    {
      	breakpoint: 868,
     	settings: {
        arrows: true,
        centerMode: false,
        slidesToShow: 1
    	  }
    	}
 	 ]
  });

  // $('.why-vitaly-section ul li a').on('click', function(e) {
  //             e.preventDefault();
  //             var headerH =  $(".header-section").height();
  //             // if (window.matchMedia('(max-width: 991px)').matches) {
  //             //     headerH = 0;
  //             // }
  //             $('html, body').animate({ 
  //                 scrollTop: $($(this).attr('href')).offset().top
  //             }, 1000);

  //         });


  
//   if($(window).width() > 600){

//     $('[data-paroller-factor]').paroller();  
//     $('.paroller').paroller({
//       factor: 0.1,
//       type: 'foreground'
//     });

//   }
  
  
   // Configure/customize these variables.
    var showChar = 120;  // How many characters are shown by default
    var ellipsestext = "...";
    var moretext = "Show more >";
    var lesstext = "Show less";
    

    $('.person-bio-txt p').each(function() {
        var content = $(this).html();
 
        if(content.length > showChar) {
 
            var c = content.substr(0, showChar);
            var h = content.substr(showChar, content.length - showChar);
 
            var html = c + '<span class="moreellipses">' + ellipsestext+ '&nbsp;</span><span class="morecontent"><span>' + h + '</span>&nbsp;&nbsp;<a href="" class="morelink">' + moretext + '</a></span>';
 
            $(this).html(html);
        }
 
    });
 
    $(".morelink").click(function(){
        if($(this).hasClass("less")) {
            $(this).removeClass("less");
            $(this).html(moretext);
        } else {
            $(this).addClass("less");
            $(this).html(lesstext);
        }
        $(this).parent().prev().toggle();
        $(this).prev().toggle();
        return false;
    });
  
  
	$(window).scroll(function(){
	
      if ($(window).scrollTop() > 50) {
        $('.header-section').removeClass('is-transparent');
      } else {
        $('.header-section').addClass('is-transparent');
      }
      
	});
  

});








$(window).load(function(){


  if (window.matchMedia("(max-width: 767px)").matches) {


    $(".simply-section .simply-title .simply-btn").insertAfter(".simply-section .simply-img");
    $(".unreal-section .left-part .unreal-button").insertAfter(".unreal-section .right-part");
    $(".feeling-section .right-part").insertAfter(".feeling-section .left-part h2 ");

    $('.tired-section .tired-box').each(function(){
      $(this).find(".right-box").insertAfter($(this).find(".left-box h2"));
    });

  }
	
  setTimeout(function(){  
    
    $(document).find('#insta-feed h2').remove();
    
  	$(".live-slide #insta-feed").slick({
    arrows: true,
    dots: false,
    autoplay: false,
    speed: 600,
    autoplaySpeed:800,
    slidesToShow:4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          arrows: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      }
    ]
  });	
  },3500);
  
});



$(document).ready(function(){



  $(".pro").click(function(){
    $(".product-detals-for").hide();
    $($(this).attr('val')).show();
    
    $('.pro').removeClass("active");
    $(this).addClass("active");

    
    $(".benifit-slider").slick('refresh');
    $(".testimonial-slider").slick('refresh');
    window.scrollBy(0,1);

    
  });


  $(".pro-navigation").click(function(){
    $(".product-detals-for").hide();
    $($(this).attr('val')).show();
    $(".benifit-slider").slick('refresh');
    $(".testimonial-slider").slick('refresh');
    
     $('.pro').removeClass("active");
    var as="[val^='"+$(this).attr('val')+"'";
    $(as).addClass("active");

  });



  $(document).on("click", ".hero-button", function(){   
    $($(this).attr('val')).show(); 
    $('.c_section').hide();
    window.scrollBy(0,1);
  })


});


$(window).load(function(){


if (window.matchMedia("(max-width: 767px)").matches) {

$('.header-section .left-nav').show();
$('.header-section .right-nav').show();

/* ==== New Menu js ===== */
$(".header-section .left-nav").appendTo(".header-section .menu-box");
$(".header-section .right-nav").appendTo(".header-section .menu-box");
$(".header-section .menu-box").prepend("<div class='close-button'><i class='fa fa-close'></i></div>");


$("#toggle").click(function(){
  $("body").addClass("menu-open");
 });


$(".header-section .menu-box .close-button .fa-close").click(function(){

  $("body").removeClass("menu-open");

});

  /* ==== End New Mwnu js ===== */



}


});






